import { keyframes, css, type StyledComponent, styled } from 'styled-components'

const fadeIn = keyframes`
	to {
		opacity: 1;
	}
`

const fadeOut = keyframes`
	to {
		opacity: 0;
	}
`

const slideIn = keyframes`
	from {
		left: -100%;
	}
	to {
		left: 0%;
	}
`
const slideOut = keyframes`
	from {
		left: 0%;
	}
	to {
		left: -100%;
	}
`

const slideDown = keyframes`
from {
	height: 0%;
}
to {
	height: 100%;
}
`
const slideUp = keyframes`
	from {
		height: 100%;	
	}
	to {
		height: 0%;
	}
`

const VERTICAL_SLIDE_IN_DURATION = 250
const CONTENT_FADE_IN_DURATION = 250
const EXTENDER_SLIDE_IN_DURATION = 250
export const TOTAL_DELAY: number =
	VERTICAL_SLIDE_IN_DURATION +
	CONTENT_FADE_IN_DURATION +
	EXTENDER_SLIDE_IN_DURATION

export const AnimatedFade: StyledComponent<
	{ $exit: boolean },
	{||},
	any
> = styled.div`
	${({ $exit }) => css`
		opacity: ${$exit ? 1 : 0};
		animation: ${$exit ? fadeOut : fadeIn} ${CONTENT_FADE_IN_DURATION}ms ease-in
			${$exit ? 0 : VERTICAL_SLIDE_IN_DURATION}ms 1 forwards;
	`}
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
`

export const InformationFrameStyle: StyledComponent<
	{||},
	{||},
	any
> = styled.div.attrs(() => ({
	className: 'bg-game-primary-600',
}))`
	font-size: var(--font-size-m);
	width: 70%;
	z-index: 1;
	${({ $exit }) => css`
		animation: ${$exit ? slideUp : slideDown} ${VERTICAL_SLIDE_IN_DURATION}ms
			ease-in ${$exit ? CONTENT_FADE_IN_DURATION : 0}ms 1 forwards;
	`}

	border-radius: 1rem;
	padding: 8px;
	position: relative;
`

export const ExtenderFrameStyle: StyledComponent<
	{ $exit: boolean, style?: {}, className?: string },
	{||},
	any
> = styled.div`
	${({ $exit }) => {
		return $exit
			? css`
					opacity: 1;
					left: 0%;
					animation: ${slideOut} ${EXTENDER_SLIDE_IN_DURATION}ms ease-in
							forwards 0ms,
						${fadeOut} 1ms linear forwards ${EXTENDER_SLIDE_IN_DURATION}ms;
			  `
			: css`
					opacity: 0;
					left: -100%;
					animation: ${fadeIn} 1ms linear forwards
							${VERTICAL_SLIDE_IN_DURATION + 0.5 * CONTENT_FADE_IN_DURATION}ms,
						${slideIn} ${EXTENDER_SLIDE_IN_DURATION}ms ease-in forwards
							${VERTICAL_SLIDE_IN_DURATION + CONTENT_FADE_IN_DURATION}ms;
			  `
	}}
`
